<template>
  <BaseTemplate class="bg_white pb48">
    <div class="mv">
      <img :src="require('@/assets/images/keepgoing/header.png')" alt="">
    </div>
    <div class="mt24"></div>
    <div class="present_container pt32 pb24 pl16 pr16">
      <h1 class="present_title rb">12カ月間ご継続ありがとうございます</h1>
      <div class="">
        <img :src="require('@/assets/images/keepgoing/thanks-text.png')" alt="">
      </div>
      <div class="mt16"></div>
      <div class="text_container bg_white">
        <p class="present_text ab">この度は製品を12ヵ月間継続してご購入いただき誠にありがとうございます。<br>日頃のご愛顧に感謝し、製品をプレゼントさせていただきます。<br>以下の中からお好きな製品をお選びください。<br>※ご選択いただいたプレゼントは、次回ご購入製品に同梱してお送りいたします。</p>
      </div>
    </div>
    <div class="mt24"></div>
    <div class="product_container pl16 pr16">
      <div class="product_list">
        <Product
          v-for="product in giftProductMap" :key="product.giftProductId"
          :product="product"
          @productClick="selectProduct(product)"
        />
      </div>
    </div>
    <PresentModal
      v-if="isModalOpen"
      :product="selectedGiftProduct"
      :disabled="isBtnDisabled"
      @onClickCorrectProduct="goPresentComplete"
      @onClickCloseModal="closeModal"
    >
      <p class="error ab mt16" v-if="errorMessage != ''">{{ errorMessage }}</p>
    </PresentModal>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from "@/views/common/BaseTemplate.vue";
import Product from "@/components/keepgoing/Product.vue";
import PresentModal from "@/components/keepgoing/PresentModal.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Plusone from '@/components/api/plusone';

export default {
  components: {
    BaseTemplate,
    Product,
    PresentModal
  },
  data() {
    return {
      isModalOpen: false,
      errorMessage: '',
      isBtnDisabled: false
    };
  },
  methods: {
    ...mapActions("keepgoing", ["fetchAllProduct"]),
    ...mapMutations("keepgoing", ["setSelectedGiftProduct"]),
    selectProduct(product) {
      console.log('product', product);
      this.setSelectedGiftProduct(product);
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.setSelectedGiftProduct(null);
      this.errorMessage = '';
    },
    goPresentComplete() {
      this.errorMessage = '';
      if(!this.selectedGiftProduct) return;
      this.isBtnDisabled = true;
      console.log('this.selectedProduct', this.selectedGiftProduct);
      Plusone.registSelectPresentInfo(this.bcNo, this.selectedGiftProduct.giftProductId).then((val) => {
        console.log('registSelectPresentInfo', val);
        this.isBtnDisabled = false;
        if(val === 'OK') {
          this.$router.push({ name: 'KeepgoingPresentComplete' });
        } else {
          this.errorMessage = 'エラーが発生しました。';
        }
      });
    }
  },
  computed: mapGetters('keepgoing', ['bcNo', 'giftProductMap', 'selectedGiftProduct']),
  mounted() {
    this.fetchAllProduct(this.bcNo);
  }
};
</script>

<style lang="css" scoped>
.present_container {
  background-color: #F4D4DF;
}
.present_title {
  font-size: 20px;
  text-shadow: 1px 1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, -1px -1px 0 #fff;
  text-align: center;
}

.present_text {
  font-size: 14px;
  line-height: 1.5;
}

.text_container {
  border-radius: 8px;
  padding: 16px;
}

.product_list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.error {
  color: red;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/keepgoing/Present.vue